import cc from 'classcat';
import { jsx } from 'react/jsx-runtime';
import { svgCls } from './styles/svg.js';

const SignShape = ({
  fillColor = "currentColor",
  shapeRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  strokeColor,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx("svg", {
    ...svgProps,
    className: cc([svgCls, svgProps.className]),
    ref: shapeRef,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    fill: fillColor,
    children: /*#__PURE__*/jsx("path", {
      d: "M117.1 0L0 117.4v165.5L117.1 400h165.5L400 282.9V117.4L282.6 0z"
    })
  });
};

export { SignShape };
//# sourceMappingURL=SignShape.js.map
